module.exports = __webpack_public_path__ + "img/漂浮元素@2x.769620e0.png";